<template>
  <!-- WAITING FOR FCM SUPPORT STATUS -->
  <div v-if="showUnsupported === null" />
  <!-- FCM IS NOT SUPPORTED  -->
  <div v-else-if="showUnsupported">
    <div class="tw:flex tw:mb-4 tw:border-l-4 tw:border-red-500 tw:p-3 tw:bg-red-200 tw:rounded-md">
      <div class="tw:flex tw:items-center">
        <i class="fas fa-bell-slash tw:text-2xl tw:text-red-500" />
      </div>
      <p class="tw:ml-3 tw:text-red-500">
        Questo browser non supporta le notifiche, utilizza uno tra
        <a href="https://www.google.com/intl/it_it/chrome/" target="_blank" class="underline">Chrome</a>,
        <a href="https://www.mozilla.org/it/firefox/new/" target="_blank" class="underline">Firefox</a> o
        <a href="https://www.microsoft.com/it-it/edge" target="_blank" class="underline">Edge</a>
      </p>
    </div>
  </div>
  <!-- FCM IS SUPPORTED -->
  <div v-else>
    <input
      type="checkbox"
      name="notification-permissions"
      :disabled="notificationStatus !== 'default' || disabled"
      :checked="notificationStatus === 'granted'"
      :indeterminate="notificationStatus === 'denied'"
      style="transform: scale(1.2)"
      @click.prevent="askForNotifications"
    >
    <label for="notification-permissions" class="tw:ml-3">
      {{
        notificationStatus === "granted"
          ? "Notifiche abilitate"
          : notificationStatus === "denied"
            ? "Notifiche disabilitate"
            : "Abilita le notifiche per un servizio migliore"
      }}
    </label>
    <div v-if="notificationStatus === 'denied'" class="tw:flex tw:mt-4 tw:border-l-4 tw:border-red-500 tw:p-3 tw:bg-red-200 tw:rounded-md">
      <div class="tw:flex tw:items-center">
        <i class="fas fa-bell-slash tw:text-2xl tw:text-red-500" />
      </div>
      <p class="tw:ml-3 tw:text-red-500">
        Permesso alle notifiche negato.
      </p>
    </div>

    <Dialog
      ref="DialogRef"
      title="Attenzione"
      :confirm-handler="askForNotificationsAndProceed"
      confirm-text="Abilita"
      cancel-text="Accedi comunque"
      :v-dialog-props="{ maxWidth: '60ch'}"
    >
      Effettuare il login senza attivare le notifiche non ti permetterà di usufruire di tutte le potenzialità di Amministro.io

      <template #[`actions.confirm`]="bindings">
        <PrimaryActionButton
          v-bind="bindings"
          :color="isSicuraSolution ? 'sicura' : 'primary'"
          @click="bindings.onConfirm()"
        />
      </template>
    </Dialog>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, shallowRef, useTemplateRef } from 'vue';
import { useFCM } from '@/composables/useFCM';
import { useBrand } from '@/composables/useBrand';
import { Dialog, PrimaryActionButton } from 'components';
import { assertDefined } from '@/lib/assert';

defineProps<{ disabled?: boolean }>();

const { askForNotifications, notificationStatus, isFCMSupported } = useFCM();
const { isSicuraSolution } = useBrand();

const DialogRef = useTemplateRef('DialogRef');
const alreadyAsked = shallowRef(false);
const showUnsupported = shallowRef<boolean | null>(null);

onBeforeMount(async () => {
  showUnsupported.value = !(await isFCMSupported());
});

async function askForNotificationsAndProceed() {
  if (!alreadyAsked.value) {
    // L'utente potrebbe chiudere il modal senza modificare le preferenze di notifica, premendo 'ACCEDI COMUNUQUE'
    // In questo caso, non gli deve essere chiesto una seconda volta di specificare di abilitare o meno le notifiche
    alreadyAsked.value = true;
    await askForNotifications();
  }
}

async function open() {
  assertDefined(DialogRef.value, 'DialogRef.value');
  return await DialogRef.value.open();
}

defineExpose({ open });
</script>
